import {header} from "./header";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {listingPagesList_template} from "../components/templates/listingPagesList_template";

declare var ko: any;
declare var page: any;

export class listing_pages extends vnModule_knockoutJS {


    protected listingPagesListTemplate: listingPagesList_template;
    protected pagination: pagination_template;
    protected timer;


    protected getModuleName(): string {

        return "listing_pages";
    }

    buildContent(): Element[] {

        this.listingPagesListTemplate = new listingPagesList_template("list", this.viewModel, this);
        this.template = this.listingPagesListTemplate;
        this.listingPagesListTemplate.setAddButtonShown(false);

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        (loadedModule as header).setHeaderTitle("Hub Pages List");

        return [this.listingPagesListTemplate.build()];
    }

    public fillPage(): void {
        this.getListFormData();
    }

    public getListFormData(): void {
        if (this.XHRHdls['listing-pages']) {
            this.XHRHdls['listing-pages'].cancelAndReset();
        }
        this.loadingIn(this.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));

        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/get';
        const usrReq_params: string[][] = [];

        usrReq_params.push(["data", ko.toJSON([])]);
        this.XHRHdls['listing-pages'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['listing-pages'].onReadyStateFunction = this.onListFormDataRequestReturn;
        this.XHRHdls['listing-pages'].execute();
    }

    protected onListFormDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                const response = JSON.parse(req.request.response);

                obj.listingPagesListTemplate.setListingPages(response.data, obj.getBrandId());

                const {contentTypes, categories} = response.extraData;

                obj.listingPagesListTemplate.setContentTypesFilterItems(contentTypes);
                obj.listingPagesListTemplate.setCategoriesFilterItems(categories);

                const execTime = Math.round((new Date().getTime() - obj.XHRHdls['listing-pages'].requestStartTime) / 1000 * 100) / 100;
                obj.listingPagesListTemplate.setResultInfo(response.totalCount, response.totalPage, execTime);
                obj.listingPagesListTemplate.setItemCount(response.totalCount);

                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();
                obj.filterList();
            });

            obj.loadingOut(obj.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));

        };
    }


    public filterList(): void {

        if (this.XHRHdls['listing-pages']) {
            this.XHRHdls['listing-pages'].cancelAndReset();
        }

        this.loadingIn(this.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));

        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/get';
        this.timer = new Date().getTime();

        const subViewModel = this.listingPagesListTemplate.getViewModelForRequest();

        this.sendFilterCall(
            usrReq_url,
            subViewModel,
            this.onFilterRequestReturn,
            XMLHttpRequestHandler_requestType.GET,
            'listing-pages',
            this.listingPagesListTemplate.builtTemplate.children.namedItem("list-results")
        );

    }

    protected onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                const responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });

            obj.loadingOut(obj.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }


    protected add() {
        this.saveViewModule(this.getMemoryViewModel());
        for ( const xhr of this.XHRHdls) {
            xhr.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/add');
    }


    protected paginationOnPageClick() {

        this.filterList();
    }


    protected listingPagesListReorder(): void {
        this.filterList();
    }

    protected filterSimpleOnChange(idElement) {
        this.listingPagesListTemplate.setPageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel() {

        if ('listing-pages' in this.XHRHdls) {
            this.XHRHdls['listing-pages'].cancelAndReset();
        }
    }


    protected updateList(response: any): void {
        this.listingPagesListTemplate.setListingPages(response.data, this.getBrandId());
        const execTime = Math.round((new Date().getTime() - this.timer) / 1000 * 100) / 100;
        this.listingPagesListTemplate.setResultInfo(response.totalCount, response.totalPage, execTime);
        this.listingPagesListTemplate.setItemCount(response.totalCount);
    }

    public viewOnWebsite(permalink: string) {

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        const url = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if (url.length === 3) { // Not on live

            if (url[0] !== "emakicms") { // Either on qa, staging or ads
                urlBegin += url[0] + ".";
            } else {
                isLocal = true;
            }
        }

        for (const item of userBrands) {
            if (item.id == idBrand) {
                window.open(urlBegin + item.domain.replace("www.", "") + (isLocal ? ("." + url[2]) : "") + permalink, "_blank");
                break;
            }
        }
    }

    protected getMemoryViewModel() {

        const templateViewModel = this.listingPagesListTemplate.getTemplateViewModel();
        delete templateViewModel.listingPages;
        return templateViewModel;
    }

    public edit(id: number): void {

        this.saveViewModule(this.getMemoryViewModel());
        let url = '/brand/' + this.getVnAppZone().app.params.idBrand + '/listing-pages/edit/';

        if (id !== 0) {
            url += id;
        }

        page(url);
    }

    protected viewListingPage(id) {

        this.saveViewModule(this.getMemoryViewModel());

        for ( const xhr of this.XHRHdls) {
            xhr.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/view/' + id + '/');
    }


    public delete(id: number): void {

        if ('delete-listing-page' in this.XHRHdls) {
            this.XHRHdls['delete-listing-page'].cancelAndReset();
        }

        this.loadingIn(this.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));

        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/delete/' + id + '/';
        const usrReq_params: string[][] = [];

        // usrReq_params.push(["data", ko.toJSON(this.listingPagesListTemplate.getViewModelForRequest())] );
        this.XHRHdls['delete-listing-page'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['delete-listing-page'].onReadyStateFunction = this.onDeleteListingPageReturn;
        this.XHRHdls['delete-listing-page'].execute();

    }

    protected onDeleteListingPageReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                obj.filterList();
                obj.loadingOut(obj.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));
            });
            obj.loadingOut(obj.listingPagesListTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    protected filterByPresets(filters) {
        this.listingPagesListTemplate.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected getSearchPresetsListData(): void {

        if ("getSearchPresetsListData" in this.XHRHdls) {
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        const subViewModel = JSON.parse(ko.toJSON(this.listingPagesListTemplate.getViewModelForRequest()));
        const usrReq_url: string = '/api/search_preset/get/';
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj) {

        return () => {

            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                obj.listingPagesListTemplate.setSearchPresets(response);
                obj.filterList();
            });
        };
    }

    protected saveSearchPreset() {

        if ("saveSearchPreset" in this.XHRHdls) {
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        const formReq_url: string = '/api/search_preset/save';
        const formReq_params: string[][] = [];

        const subViewModel = JSON.parse(ko.toJSON(this.listingPagesListTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetListingPages;
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetListingPages(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);

                obj.listingPagesListTemplate.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });

        };
    }

    protected saveFavoriteSearchPreset(params: { presetId: number, searchPresetType: string }): void {

        if ("saveFavoriteSearchPreset" in this.XHRHdls) {
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        const formReq_url: string = '/api/search_preset/favorite/save/';
        const formReq_params: string[][] = [];

        const subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles;
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });

        };
    }

    protected deleteSearchPreset(presetId: number): void {

        if ("deleteSearchPreset" in this.XHRHdls) {
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        const usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        const usrReq_params: string[][] = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj) {
        return () => {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);
            });
        };
    }

    protected getTagsSuggestion(keyword, idElement) {

        if( "getTagsSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        const subViewModel = {filter: {keyword}, idElement};
        const usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagsSuggestion']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagsSuggestion'].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls['getTagsSuggestion'].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                const responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags) {
                    obj.listingPagesListTemplate.setTagFilter(responseParsed.data.tags);
                }

            });
        }
    }

    protected setDefaultStatusFilters() {
        this.listingPagesListTemplate.setDefaultFilters();
    }

    protected filterMultipleSelectorOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

}


// WEBPACK FOOTER //
// ./js/modules/listing_pages.ts